module.exports = __webpack_public_path__ + "static/media/favicon.e06546d5.png";